module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1